export const SvgDataset = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="40" height="40" rx="8" fill="#FBF9FF" />
    <path
      d="M20.5 16.5C26.0228 16.5 30.5 15.1569 30.5 13.5C30.5 11.8431 26.0228 10.5 20.5 10.5C14.9772 10.5 10.5 11.8431 10.5 13.5C10.5 15.1569 14.9772 16.5 20.5 16.5Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8854 15.75C11.8094 16.2997 10.5 17.104 10.5 18C10.5 19.6568 14.9771 21 20.5 21C26.0229 21 30.5 19.6568 30.5 18C30.5 17.104 29.1906 16.2997 27.1145 15.75C25.3517 16.2167 23.0361 16.5 20.5 16.5C17.9639 16.5 15.6482 16.2167 13.8854 15.75Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8854 20.25C11.8094 20.7997 10.5 21.604 10.5 22.5C10.5 24.1568 14.9771 25.5 20.5 25.5C26.0229 25.5 30.5 24.1568 30.5 22.5C30.5 21.604 29.1906 20.7997 27.1145 20.25C25.3517 20.7167 23.0361 21 20.5 21C17.9639 21 15.6482 20.7167 13.8854 20.25Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8854 24.75C11.8094 25.2997 10.5 26.104 10.5 27C10.5 28.6568 14.9771 30 20.5 30C26.0229 30 30.5 28.6568 30.5 27C30.5 26.104 29.1906 25.2997 27.1145 24.75C25.3517 25.2167 23.0361 25.5 20.5 25.5C17.9639 25.5 15.6482 25.2167 13.8854 24.75Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgLinkOff = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.90474 6.86259L11.319 5.44838C13.2716 3.49575 16.4374 3.49575 18.39 5.44838V5.44838C20.3426 7.401 20.3426 10.5668 18.39 12.5194L16.9758 13.9337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.0589 16.8505L12.6447 18.2648C10.692 20.2174 7.52622 20.2174 5.5736 18.2648V18.2648C3.62098 16.3121 3.62098 13.1463 5.5736 11.1937L6.98781 9.77948"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M14.5894 9.24915L8.66734 15.1712" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M18.9165 16.3621L21.8143 17.1385" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5.23779 7.60889L2.34002 6.83243" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M17.23 21.7227L16.4535 18.8249" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6.86182 2.31079L7.63827 5.20857" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
